import React from 'react';
import PropTypes from 'prop-types';

import styles from './matchInteraction.scss';
import customFieldsService from '../../../../services/CustomFieldsService';
import scorableItemNumberingService from '../../../../services/questionView/ScorableItemNumberingService';
import PaperBasedInput from '../paperBasedInteraction/PaperBasedInteractionInput';

class MatchPaperBased extends React.Component {
    static propTypes = {
        model: PropTypes.object.isRequired, // model taken from responseModels related to this interaction
        services: PropTypes.object.isRequired,
        questionModel: PropTypes.object,

    };

    getPBOrderNumber(choiceIdentifier) {
        const { model, questionModel } = this.props;
        const number = scorableItemNumberingService.getInteractionChoiceNumber(
            questionModel.contentRevisionId,
            model.identifier,
            choiceIdentifier
        );
        if (number) {
            return (<span className={styles.pbInputNumber}>{number}</span>);
        }
        return null;
    }

    getPBInput(choiceIdentifier) {
        const { questionModel } = this.props;
        const showPaperBasedInput = (
            !customFieldsService.isMatchingFeature(questionModel)
            && !customFieldsService.isMatchingInformation(questionModel)
        );
        const isShortSize = customFieldsService.isMatchingPlanMapDiagramLabelling(questionModel) || customFieldsService.isMatching2(questionModel);

        if (showPaperBasedInput) {
            return (
                <PaperBasedInput key={`pb-input_${choiceIdentifier}`} isShortSize={isShortSize} />
            );
        }
        return null;
    }

    render() {
        const { model, questionModel, services } = this.props;
        const showOptionBox = (
            !customFieldsService.isMatchingFeature(questionModel)
            && !customFieldsService.isMatchingInformation(questionModel)
            && !customFieldsService.isMatchingPlanMapDiagramLabelling(questionModel)
        );

        return (
            <div className={styles.matchPaperBased}>
                {
                    showOptionBox
                        ? <div className={styles.pbOptionBox}>
                            {
                                model.alternatives[1].map((columnChoice, index) => (
                                    <div className={styles.pbBoxOption} key={`pb-option_${columnChoice.identifier}`}>
                                        <span className={styles.pbBoxOptionNumber}>{services.utilService.toLatinLetter(index + 1)}</span>
                                        <div
                                            className={styles.pbBoxOptionContent}
                                            dangerouslySetInnerHTML={{ __html: columnChoice.content }}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                        : null
                }
                {
                    customFieldsService.isMatching2(questionModel)
                        ? <h2 className="title" dangerouslySetInnerHTML={{ __html: model.prompt.content }} />
                        : null
                }
                {
                    model.alternatives[0].map(rowChoice => (
                        <div className={styles.pbInputRow} key={`row_${rowChoice.identifier}`}>
                            {this.getPBOrderNumber(rowChoice.identifier)}
                            <span className={styles.pbRowValue} dangerouslySetInnerHTML={{ __html: rowChoice.content }} />
                            <span className={styles.pbLastCell}>
                                {this.getPBInput(rowChoice.identifier)}
                            </span>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default MatchPaperBased;
